import cookie from 'js-cookie';

const TEN_YEARS_DAYS = 365 * 10;

export const setAblyCookie = async (
  name: string,
  value: string,
): Promise<void> => {
  cookie.set(name, value, {
    domain: '.a-bly.com',
    path: '/',
    expires: TEN_YEARS_DAYS,
  });
};
